<template>
  <!-- ホーム画面 -->
  <div id="philipsHome">
    <div class="flex-container">
      <div class="flex-item" v-if="listOfNoticeData.length > 0">
        <div class="content-title">お知らせ</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(1)">すべて見る </a>
        </div>
        <b-table :data="filterdListOfNoticeData" class="notice-table">
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル">
              <a
                @click="
                  showModal(
                    props.row.title,
                    props.row.content,
                    props.row.createdAt
                  )
                "
                >{{ props.row.title }}</a
              >
            </b-table-column>
            <b-table-column field="content" label="本文">
              {{ props.row.content }}
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="listOfGuidanceData.length > 0">
        <div class="content-title">ご案内</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(2)"> すべて見る </a>
        </div>
        <b-table :data="filterdListOfGuidanceData" class="guidance-table">
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル">
              <a @click="downloadFile(props.row.pdfFileUrl)">{{
                props.row.title
              }}</a>
            </b-table-column>
            <b-table-column field="product_code" label="製品名">
              {{ props.row.productNames }}
            </b-table-column>
            <b-table-column label="PDF閲覧" centered>
              <a @click="downloadFile(props.row.pdfFileUrl)"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item" v-if="listOfEventData.length > 0">
        <div class="content-title">学会・イベント情報</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(3)"> すべて見る </a>
        </div>
        <div class="event-news-container">
          <div class="event-news-item1">
            <a @click="downloadFile(listOfEventData[0].pdfFileUrl)"
              ><img
                v-if="
                  listOfEventData.length > 0 && listOfEventData[0].imageFileUrl
                "
                :src="listOfEventData[0].imageFileUrl"
                class="event-news-hero-img" />
              <img
                v-else
                src="@/assets/image-off-outline.svg"
                class="event-news-hero-img"
            /></a>
            <div>
              {{ listOfEventData.length > 0 ? listOfEventData[0].title : "" }}
            </div>
          </div>
          <div class="event-news-item2-4">
            <b-table :data="filterdListOfEventData" class="event-table">
              <template slot-scope="props">
                <b-table-column field="title" label="タイトル">
                  <a @click="downloadFile(props.row.pdfFileUrl)">{{
                    props.row.title
                  }}</a>
                </b-table-column>
                <b-table-column field="pdfUrl" label="PDF閲覧" centered>
                  <a @click="downloadFile(props.row.pdfFileUrl)"
                    ><b-icon icon="clipboard-arrow-right-outline"
                  /></a>
                </b-table-column>
                <b-table-column filed="externalUrl" label="関連サイト" centered>
                  <a
                    v-if="props.row.externalLinkUrl"
                    @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                    class="infoicon"
                    ><b-icon icon="earth-arrow-right"
                  /></a>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="flex-item" v-if="listOfNewsData.length > 0">
        <div class="content-title">ニュース</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(4)"> すべて見る </a>
        </div>
        <div class="event-news-container">
          <div class="event-news-item1">
            <a @click="goToTitleLinkUrl(listOfNewsData[0].titleLinkUrl)"
              ><img
                v-if="
                  listOfNewsData.length > 0 && listOfNewsData[0].imageFileUrl
                "
                :src="listOfNewsData[0].imageFileUrl"
                class="event-news-hero-img" />
              <img
                v-else
                src="@/assets/image-off-outline.svg"
                class="event-news-hero-img"
            /></a>
            <div>
              {{ listOfNewsData.length > 0 ? listOfNewsData[0].title : "" }}
            </div>
          </div>
          <div class="event-news-item2-4">
            <b-table :data="filterdListOfNewsData" class="news-table">
              <template slot-scope="props">
                <b-table-column field="title" label="タイトル">
                  <a @click="goToTitleLinkUrl(props.row.titleLinkUrl)">{{
                    props.row.title
                  }}</a>
                </b-table-column>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="flex-item" v-if="listOfProductData.length > 0">
        <div class="content-title">製品情報</div>
        <div class="a-left">
          <a class="view-all" @click="goToArticleList(5)"> すべて見る </a>
        </div>
        <b-table :data="filterdListOfProductData" class="product-table">
          <template slot-scope="props">
            <b-table-column field="title" label="タイトル">
              <a
                v-if="props.row.pdfFileUrl"
                @click="downloadFile(props.row.pdfFileUrl)"
                >{{ props.row.title }}</a
              >
              <a
                v-else-if="props.row.externalLinkUrl"
                @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                >{{ props.row.title }}</a
              >
            </b-table-column>
            <b-table-column field="product_code" label="製品名">
              {{ props.row.productNames }}
            </b-table-column>
            <b-table-column field="target_audience_code" label="対象者">
              {{ props.row.targetAudienceName }}
            </b-table-column>
            <b-table-column label="PDF閲覧" centered>
              <a
                @click="downloadFile(props.row.pdfFileUrl)"
                v-show="props.row.pdfFileUrl"
                ><b-icon icon="clipboard-arrow-right-outline"
              /></a>
            </b-table-column>
            <b-table-column label="関連サイト" centered>
              <a
                v-if="props.row.externalLinkUrl"
                @click="goToExternalLinkUrl(props.row.externalLinkUrl)"
                class="infoicon"
                ><b-icon icon="play-box-multiple"
              /></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
      <div class="flex-item">
        <div class="content-title" style="height: auto">
          <div>無呼吸ラボはこちらから</div>
          <div class="lab-img">
            <a
              href="https://mukokyu-lab.jp/"
              target="_blank"
              rel="noopener noreferrer"
              ><img
                src="@/assets/images/apnea-lab-banner-image.jpeg"
                style="height: 180px"
            /></a>
          </div>
        </div>
      </div>
      <div class="terms-of-use-area">
        <div class="terms-of-use">
          <a
            href="https://www.philips.co.jp/a-w/terms-of-use"
            style="color: blue"
            >ご利用条件</a
          >
        </div>
        <div class="caveat">
          <span
            >本サイトの利用者は、利用条件を承認したとみなされますので、利用条件をご確認ください。</span
          >
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="caveatPasswordChange"
      @close="closeModal"
      has-modal-card
    >
      <caveatPasswordChange-modal></caveatPasswordChange-modal>
    </b-modal>
    <b-modal
      :active.sync="noticeModalActive"
      :width="640"
      :height="640"
      scroll="keep"
    >
      <div class="modal-notice">
        <div class="content">
          <div class="modal-headline">【お知らせ】</div>
          <div class="modal-title">「{{ modalTitle }}」</div>
          <div class="modal-content">{{ modalContent }}</div>
          <div class="modal-createdAt">{{ modalCreatedAt }}</div>
          <b-button class="is-primary" @click="noticeModalActive = false"
            >閉じる</b-button
          >
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { role } from "@/components/mock/base/const.js";
import header from "../base/header.vue";

const caveatPasswordChangeForm = {
  props: [],
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var passwordLimit = userInfo.passwordLimit;
    return {
      userInfo,
      passwordLimit,
    };
  },
  methods: {
    inputAnswerYes: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.$router.push({ path: "/philips/profile/UserProfile" });
      this.$parent.close();
    },
    inputAnswerNo: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.$parent.close();
    },
  },
  template: `
        <div class="modal-card" style="width: 500px;">
          <header class="modal-card-head">
              <p class="modal-card-title" style="color: whitesmoke;">パスワード変更依頼</p>
          </header>
          <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
            <div>
              <p>パスワードの有効期限がまもなく終了します。<br>
              「ユーザープロファイル」からパスワードの<br>変更をお願いいたします。<br>
              パスワード有効期限：{{passwordLimit}} まで</p>
            </div>
          </section>
          <footer class="modal-card-foot">
            <div>
            <b-button
              class="button is-primary is-inverted has-text-centered"
              type="button"
              v-on:click="inputAnswerYes"
            >
            はい
            </b-button>
            <b-button
              class="button is-light is-inverted has-text-centered"
              v-on:click="inputAnswerNo"
            >いいえ</b-button>
            </div>
          </footer>
        </div>
      `,
};

export default {
  components: { header },
  name: "philipsHome",
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var caveatPasswordChange = false;
    if (
      userInfo.nearPasswordForceChange &&
      !userInfo.nearPasswordChangeAnswer
    ) {
      caveatPasswordChange = true;
    }
    return {
      notice: "",
      role: role,
      caveatPasswordChange,
      userInfo,
      listOfNoticeData: [],
      listOfGuidanceData: [],
      listOfEventData: [],
      listOfNewsData: [],
      listOfProductData: [],
      filterdListOfNoticeData: [],
      filterdListOfGuidanceData: [],
      filterdListOfEventData: [],
      filterdListOfNewsData: [],
      filterdListOfProductData: [],
      noticeModalActive: false,
      modalTitle: "",
      modalContent: "",
      modalCreatedAt: "",
    };
  },
  methods: {
    closeModal: function (event) {
      this.userInfo.nearPasswordChangeAnswer = true;
      sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.caveatPasswordChange = false;
    },
    goToArticleList(type) {
      this.$router.push({ path: "/guest/article-list?type=" + type });
    },
    goToExternalLinkUrl(externalLinkUrl) {
      const url = externalLinkUrl;
      window.open(url, "_blank");
    },
    goToTitleLinkUrl(titlelLinkUrl) {
      const url = titlelLinkUrl;
      window.open(url, "_blank");
    },
    showModal(title, content, createdAt) {
      this.modalTitle = title;
      this.modalContent = content;
      this.modalCreatedAt = createdAt;
      this.noticeModalActive = true;
    },
    // ホーム画面　掲載記事取得
    searchHomePortalArticles() {
      const THIS = this;
      return this.apiAnsyncCall(
        function (client) {
          return client.apis.portalHome.searchHomePortalArticles();
        },
        function (success) {
          if (success.obj.portalNoticeList) {
            THIS.listOfNoticeData = success.obj.portalNoticeList;
          } else {
            THIS.listOfNoticeData = 0;
          }
          for (let i = 0; THIS.listOfNoticeData.length > i; i++) {
            THIS.filterdListOfNoticeData.push(THIS.listOfNoticeData[i]);
            if (i == 4) break;
          }
          if (success.obj.portalGuidanceList) {
            THIS.listOfGuidanceData = success.obj.portalGuidanceList;
          } else {
            THIS.listOfGuidanceData = 0;
          }
          for (let i = 0; THIS.listOfGuidanceData.length > i; i++) {
            THIS.filterdListOfGuidanceData.push(THIS.listOfGuidanceData[i]);
            if (i == 4) break;
          }
          if (success.obj.portalEventList) {
            THIS.listOfEventData = success.obj.portalEventList;
          } else {
            THIS.listOfEventData = 0;
          }
          for (let i = 0; THIS.listOfEventData.length > i; i++) {
            if (i == 0) continue;
            THIS.filterdListOfEventData.push(THIS.listOfEventData[i]);
            if (i == 3) break;
          }
          if (success.obj.portalNewsList) {
            THIS.listOfNewsData = success.obj.portalNewsList;
          } else {
            THIS.listOfNewsData = 0;
          }
          for (let i = 0; THIS.listOfNewsData.length > i; i++) {
            if (i == 0) continue;
            THIS.filterdListOfNewsData.push(THIS.listOfNewsData[i]);
            if (i == 3) break;
          }
          if (success.obj.portalProductList) {
            THIS.listOfProductData = success.obj.portalProductList;
          } else {
            THIS.listOfProductData = 0;
          }
          for (let i = 0; THIS.listOfProductData.length > i; i++) {
            THIS.filterdListOfProductData.push(THIS.listOfProductData[i]);
            if (i == 2) break;
          }
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
    downloadFile(fileAddress) {
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getDownloadFilePOST({
            body: {
              fileId: 0,
              fileName: fileAddress,
            },
          });
        },
        function (result) {
          var downloadUrl = result.obj.downloadUrl;
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = downloadUrl;
          let targetFile = fileAddress.toLowerCase();
          if (targetFile.endsWith(".pdf")) {
            a.target = "_blank";
          }
          a.click();
          a.remove();
        },
        function (error) {
          THIS.showErrorMessage(error);
        }
      );
    },
  },
  components: {
    "caveatPasswordChange-modal": caveatPasswordChangeForm,
  },
  mounted() {
    this.searchHomePortalArticles();
  },
};
</script>
<style lang="scss" scoped>
.notice {
  font-size: 25px;
}
.noticeTextArea {
  width: 100%;
  height: 250px;
}
.content-title {
  font-size: 25px;
  text-align: left;
}
.view-all {
  color: #1c29e6;
  font-size: 15px;
}
.a-left {
  text-align: left;
  margin: 5px 0 5px 0;
  text-align: left;
}
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: auto;
  z-index: 1;
  float: left;
}
.flex-item:nth-child(odd) {
  background-color: #d8eaff;
  margin: 0 10px 10px 0;
  padding: 5px;
  width: 49%;
  height: auto;
}
.flex-item:nth-child(even) {
  background-color: #d8eaff;
  margin: 0 0 10px 0;
  padding: 5px;
  width: 49%;
  height: auto;
}
.flex-item:last-child {
  background-color: #d8eaff;
  margin: 0 0 10px 0;
  padding: 5px;
  width: 49%;
  height: auto;
}
.info-icon {
  width: 24px;
}
/* PDFアイコンセンタリング*/
.table-wrapper > table > tbody > tr > td {
  vertical-align: middle;
}
.event-news-hero-img {
  object-fit: contain;
  height: 120px;
}
.event-news-container {
  display: grid;
  grid-template-columns: 30% 68%;
  grid-template-rows: auto;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas: "event-news-item1 news-item2-4";
}
.event-news-item1 {
  grid-area: event-news-item1;
  margin: 0 5px 0 0;
  background-color: #fff;
}
.news-item2-4 {
  grid-area: news-item2-4;
  height: auto;
}
/* ラベル名フォントサイズ */
.table-wrapper > table > thead {
  font-size: 12px;
  vertical-align: middle;
}
.table-wrapper > table > thead > tr > th > div {
  font-size: 12px;
  vertical-align: middle;
}
/* タイトル以外フォントサイズ */
.table-wrapper > table > tbody > tr > td > span {
  font-size: 12px;
  vertical-align: middle;
}
/* 掲載記事タイトルフォントサイズ */
.table-wrapper > table > tbody > tr > td > span > a {
  padding: auto;
  vertical-align: middle;
  font-size: 16px;
}
.table-wrapper > table > tbody > tr > td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lab-img {
  text-align: center;
  vertical-align: middle;
  height: auto;
}
.terms-of-use-area {
  width: 100%;
}
.terms-of-use {
  margin: auto;
  height: 50px;
  width: 100%;
  color: blue;
  padding: 20px;
  font-size: 18px;
}
.caveat {
  width: 100%;
  font-size: 15px;
  margin-bottom: 50px;
}
.content {
  background-color: #fff;
  margin: auto;
  padding: 36px;
}
.modal-headline {
  font-size: 36px;
  text-align: left;
  margin: 20px 0 20px 0;
}
.modal-title {
  font-size: 24px;
  text-align: left;
  margin: 0 0 2px 0;
}
.modal-content {
  font-size: 18px;
  text-align: left;
  margin: 0 0 50px 0;
}
.modal-createdAt {
  font-size: 16px;
  text-align: left;
  margin: 0 0 10px 0;
}
</style>
<style>
#philipsHome .b-table .table {
  table-layout: fixed;
}
/* notice-table */
#philipsHome .notice-table .table > thead > tr > th:nth-child(1) {
  width: 60%;
}
/* guidance-table */
#philipsHome .guidance-table .table > thead > tr > th:nth-child(1) {
  width: 70%;
}
#philipsHome .guidance-table .table > thead > tr > th:nth-child(2) {
  width: 22%;
}
#philipsHome .guidance-table .table > thead > tr > th:nth-child(3) {
  width: 8%;
}
/* event-table */
#philipsHome .event-table .table > thead > tr > th:nth-child(1) {
  width: 70%;
}
#philipsHome .event-table .table > thead > tr > th:nth-child(2) {
  width: 15%;
}
#philipsHome .event-table .table > thead > tr > th:nth-child(3) {
  width: 15%;
}
/* product-table */
#philipsHome .product-table .table > thead > tr > th:nth-child(1) {
  width: 47%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(2) {
  width: 23%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(3) {
  width: 12%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(4) {
  width: 8%;
}
#philipsHome .product-table .table > thead > tr > th:nth-child(5) {
  width: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/home.vue